import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { FlexBox, FlexItem } from '@codex-brightworld/basics';

export const Heading = styled.h2`
  display: inline-block;
  margin: 0 5px 5px 0;
  font-size: 18px;
  font-weight: normal;

  b {
    color: ${props => props.theme.colors.primary.magenta};
    font-weight: normal;
  }

  @media ${props => props.theme.breakpoints.mobile} {
    margin: 0 5px 0 0;
  }
`;

export const Sale = styled.div`
  display: inline-block;
  padding: 10px 8px 9px;
  background-color: ${props => props.theme.colors.primary.magenta};
  color: ${props => props.theme.colors.shades[7]};
  font-size: 14px;
  border-radius: 4px;

  @media ${props => props.theme.breakpoints.mobile} {
    padding: 8px 8px 9px;
  }
`;

const BundleHeader = props => (
  <FlexBox>
    <FlexItem grow={1} basis="30%">
      <Heading>{props.children}</Heading>
    </FlexItem>

    {props.discountLabel && (
      <FlexItem alignSelf="flex-end">
        <Sale>{props.discountLabel}</Sale>
      </FlexItem>
    )}
  </FlexBox>
);

BundleHeader.propTypes = {
  children: PropTypes.node,
  discountLabel: PropTypes.string
};

BundleHeader.defaultProps = {
  children: undefined,
  discountLabel: ''
};

export default BundleHeader;
